import toTitleCase from '@smart-tv/utils/string/to-title-case';

import getMonth from '../get-month/get-month';

export const NAMES = [
  'januar',
  'februar',
  'marts',
  'april',
  'maj',
  'juni',
  'juli',
  'august',
  'september',
  'oktober',
  'november',
  'december'
];

export const ABBREVIATED_NAMES = [
  'jan',
  'feb',
  'mar',
  'apr',
  'maj',
  'jun',
  'jul',
  'aug',
  'sep',
  'okt',
  'nov',
  'dec'
];

export const getMonthName = (
  date: Date | number,
  options?: { titleCase?: boolean; abbreviate?: boolean }
): string => {
  const month = getMonth(date);
  const name = options?.abbreviate ? ABBREVIATED_NAMES[month] : NAMES[month];

  return options?.titleCase ? toTitleCase(name) : name;
};

export default getMonthName;
